import { render } from "./stock-adjustment-report.vue?vue&type=template&id=63ccd558&scoped=true"
import script from "./stock-adjustment-report.vue?vue&type=script&lang=js"
export * from "./stock-adjustment-report.vue?vue&type=script&lang=js"

import "./stock-adjustment-report.vue?vue&type=style&index=0&id=63ccd558&scoped=true&lang=css"

import exportComponent from "C:\\xampp\\htdocs\\personal\\ims-frontend\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-63ccd558"]])

export default __exports__